var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFlashOff = function SvgIcFlashOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.896 6.896a.5.5 0 0 1 .707 0l13.5 13.5a.5.5 0 0 1-.707.707l-13.5-13.5a.5.5 0 0 1 0-.707"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.407 18.529-4.053 5.075c-.507.635-1.529.196-1.418-.61l1.07-7.748-3.735.615c-.723.12-1.212-.716-.755-1.289l2.19-2.744zm1.256-1.573-.628.786-6.7-6.7.628-.786zm-2.018-12.56c.508-.635 1.53-.197 1.418.608l-1.07 7.747 3.735-.614c.723-.119 1.212.716.755 1.289l-2.192 2.744-6.7-6.7z"
  })));
};
export default SvgIcFlashOff;